import i18n from 'i18next';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import icBack from '../../../assets/imgs/ic_btn_back.svg?react';
import icMinus from '../../../assets/imgs/ic_minus.svg?react';
import icPlus from '../../../assets/imgs/ic_plus.svg?react';
import BoughtSpotTicket from '../../../components/BoughtSpotTicket/BoughtSpotTicket';
import CenterLoading from '../../../components/CenterLoading/CenterLoading';
import useUsageSpotTicket from '../../../hooks/useUsageSpotTicket';
import { convertTextToLinks, getValueByLanguage } from '../../../utils';
import { USAGE_TICKET_STATUS } from '../../../utils/Constants';
import styles from './styles.module.css';
import CustomAntButton from '../../../components/CustomAntButton/CustomAntButton';
import { OrderTicket, SpotInfo } from 'types';

const SpotNumberSelectionScreen = memo(() => {
    const [numberOfUseTicket, setNumberOfUseTicket] = useState<number>(1);
    const [maxTicketsQuantity, setMaxTicketsQuantity] = useState<number>();
    const [isHiddenSelectQuantity, setIsHiddenSelectQuantity] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const { orderTicket, spotInfo }: { orderTicket: OrderTicket; spotInfo: SpotInfo } = location.state ?? {};
    const { checkUsageSpotTicket, ActivateConfirmModal, loading } = useUsageSpotTicket();

    useEffect(() => {
        const couponTickets = orderTicket?.orderUsageTickets ?? [];
        const availableCoupon = couponTickets.filter((coupon) => coupon.status === USAGE_TICKET_STATUS.BOUGHT).length;
        if (availableCoupon <= 0) {
            navigate('/bought');
            return;
        }
        setIsHiddenSelectQuantity(couponTickets?.length === 1);
        setMaxTicketsQuantity(availableCoupon);
    }, [orderTicket, navigate]);

    /**
     * 戻るボタンの処理
     */
    const handleBackButton = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    /**
     * チケットの枚数を上げるの処理
     */
    const handleIncrementClick = useCallback(() => {
        if (typeof maxTicketsQuantity !== 'number') return;
        setNumberOfUseTicket((prev) => (prev >= maxTicketsQuantity ? maxTicketsQuantity : prev + 1));
    }, [maxTicketsQuantity]);

    /**
     * チケットの枚数を下げるの処理
     */
    const handleDecrementClick = useCallback(() => {
        setNumberOfUseTicket((prev) => (prev > 1 ? prev - 1 : 1));
    }, []);

    return (
        <>
            {loading && <CenterLoading overFooter={true} />}
            <ActivateConfirmModal spotInfo={spotInfo} numberOfUseTicket={numberOfUseTicket} />
            {orderTicket != null && (
                <div className={`${styles.wrapper} scrollable`}>
                    <div className={styles.backIconView} onClick={handleBackButton}>
                        {React.createElement(icBack, { className: styles.backIcon })}
                    </div>
                    <BoughtSpotTicket orderTicket={orderTicket} isTicketUsed={false} spotInfo={spotInfo} />
                    <p className={styles.spotNote}>
                        {convertTextToLinks(getValueByLanguage(spotInfo.note, i18n.language))}
                    </p>
                    <div className={styles.ticketQuantity}>
                        {!isHiddenSelectQuantity && (
                            <div className={styles.selectUsageNumber}>
                                <p>{t('spot-code.select-usage-number')}</p>
                                <div>
                                    <button className={styles.decrementBtn} onClick={handleDecrementClick}>
                                        {React.createElement(icMinus)}
                                    </button>
                                    <p className={styles.numberResult}>{numberOfUseTicket}</p>
                                    <button className={styles.incrementBtn} onClick={handleIncrementClick}>
                                        {React.createElement(icPlus)}
                                    </button>
                                </div>
                            </div>
                        )}
                        <CustomAntButton className={styles.useBtn} onClick={() => checkUsageSpotTicket(orderTicket)}>
                            <span>{t('button.use-spot-code-ticket')}</span>
                        </CustomAntButton>
                    </div>
                    <p className={styles.note}>
                        {convertTextToLinks(getValueByLanguage(orderTicket.note, i18n.language))}
                    </p>
                </div>
            )}
        </>
    );
});

export default SpotNumberSelectionScreen;
